import { INodeTemplate } from '@/types/node';
import { WidgetSettings } from '@/widget-editor/components';
import {
  withWidgetDisplay,
  withWidgetSettings,
} from '@/widget-editor/utilities';
import { Settings } from '@/nodes/programtimeline/edit';
import {
  Render as ProgramRender,
  template as programTemplate,
} from '@/nodes/programtimeline';

const template: INodeTemplate = {
  version: 1,
  name: 'Program Timeline Widget',
  icon: programTemplate.icon,
  type: 'programtimeline-widget',
  tag: 'widgets',
  content: {
    widgetName: 'Program Timeline Widget',
    ...programTemplate.content,
  },
  override: {
    root: {},
  },
  supports: {
    contexts: ['room'],
    appender: true,
  },
};

const Render = withWidgetDisplay(ProgramRender);

const Edit = withWidgetSettings(WidgetSettings)(Settings);

export { template, Render, Edit };
